import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  assignments: {
    id: 'gradebook.GradebookFilters.assignmentsFilterLabel',
    defaultMessage: 'Assignments',
    description: 'Assignment filter group label in Gradebook Filters',
  },
  overallGrade: {
    id: 'gradebook.GradebookFilters.overallGradeFilterLabel',
    defaultMessage: 'Overall Grade',
    description: 'Overall Grade filter group label in Gradebook Filters',
  },
  studentGroups: {
    id: 'gradebook.GradebookFilters.studentGroupsFilterLabel',
    defaultMessage: 'Student Groups',
    description: 'Student Groups filter group label in Gradebook Filters',
  },
  includeCourseTeamMembers: {
    id: 'gradebook.GradebookFilters.includeCourseTeamMembersFilterLabel',
    defaultMessage: 'Include Course Team Members',
    description: 'Include Course Team Members filter label in Gradebook Filters',
  },
  assignment: {
    id: 'gradebook.GradebookFilters.assignmentFilterLabel',
    defaultMessage: 'Assignment',
    description: 'Assignment filter select label in Gradebook Filters',
  },
  assignmentTypes: {
    id: 'gradebook.GradebookFilters.assignmentTypesLabel',
    defaultMessage: 'Assignment Types',
    description: 'Assignment Types filter select label in Gradebook Filters',
  },
  maxGrade: {
    id: 'gradebook.GradebookFilters.maxGradeFilterLabel',
    defaultMessage: 'Max Grade',
    description: 'Max-grade filter select label in Gradebook Filters',
  },
  minGrade: {
    id: 'gradebook.GradebookFilters.minGradeFilterLabel',
    defaultMessage: 'Min Grade',
    description: 'Min-grade filter select label in Gradebook Filters',
  },
  cohorts: {
    id: 'gradebook.GradebookFilters.cohorts',
    defaultMessage: 'Cohorts',
    description: 'Cohorts filter select label in Gradebook Filters',
  },
  cohortAll: {
    id: 'gradebook.GradebookFilters.cohortsAll',
    defaultMessage: 'Cohort-All',
    description: 'Cohorts filter select default in Gradebook Filters',
  },
  tracks: {
    id: 'gradebook.GradebookFilters.tracks',
    defaultMessage: 'Tracks',
    description: 'Tracks filter select label in Gradebook Filters',
  },
  trackAll: {
    id: 'gradebook.GradebookFilters.trackAll',
    defaultMessage: 'Track-All',
    description: 'Tracks filter select default in Gradebook Filters',
  },
  closeFilters: {
    id: 'gradebook.GradebookFilters.closeFilters',
    defaultMessage: 'Close Filters',
    description: 'Button label for Close button in Gradebook Filters',
  },
  apply: {
    id: 'gradebook.GradebookFilters.apply',
    defaultMessage: 'Apply',
    description: 'Apply filter button text',
  },
});

export default messages;
